module.exports = __webpack_public_path__ + "img/icon_zhiwen@3x.26bd9e10.png";